import React from "react";
import { Link } from "react-router-dom";
import { IconType } from "../../../assets/IconType";

export interface ReportBlockConfig {
	heading: string;
	Icon: IconType;
	link?: string;
	links?: {
		text: string;
		section?: string;
	}[];
	children?: React.ReactNode;
}

export interface ReportBlockProps {
	block: ReportBlockConfig;
	className?: string;
}

export function ReportBlock(props: ReportBlockProps) {
	const config = props.block;
	const { Icon } = config;
	return (
		<div className={`flex w-full md:min-h-32 pb-4 border-b-2 ${props.className}`}>
			<div>
				{config.link ? (
					<Link to={config.link} className="cursor-pointer">
						<Icon className="h-20 text-primary-700" />
					</Link>
				) : (
					<Icon className="h-20 text-primary-700" />
				)}
			</div>
			<div className="pl-4 pt-1">
				<h2>{config.heading}</h2>
				{config.link && config.links && (
					<ul className="pt-1">
						{config.links.map((link, index) => (
							<li key={index}>
								<Link
									to={config.link!}
									className="cursor-pointer"
									state={link.section ? { section: link.section } : {}}>
									{link.text}
								</Link>
							</li>
						))}
					</ul>
				)}
				{config.children}
			</div>
		</div>
	);
}
